<template>
  <section class="section">
    <a-space direction="vertical" :size="20">
      <div class="section__item">
        <a-typography-text strong> Tipo de estrategia: </a-typography-text>
        <p class="mrg-bottom-0 gray-8">{{ dataSource.type_strategy_name }}</p>
      </div>
      <div class="section__item">
        <a-typography-text strong> Empresa: </a-typography-text>
        <p class="mrg-bottom-0 gray-8">{{ dataSource.entity.name }}</p>
      </div>
      <div class="section__item">
        <a-typography-text strong> Campaña: </a-typography-text>
        <p class="mrg-bottom-0 gray-8">{{ dataSource.portfolio.name }}</p>
      </div>
      <div v-if="isEmail" class="section__email">
        <div class="section__item">
          <a-typography-text strong>
            Dirección remitente:

            <a-tooltip title="Identificador de correo">
              <InfoCircleOutlined />
            </a-tooltip>
          </a-typography-text>
          <p class="mrg-bottom-0 gray-8">{{ emailAddress }}</p>
        </div>
        <div class="section__item">
          <a-typography-text strong> Asunto: </a-typography-text>
          <p class="mrg-bottom-0 gray-8">
            {{ subject }}
          </p>
        </div>
        <div class="section__item">
          <a-typography-text strong> Vista previa del correo: </a-typography-text>
          <p class="mrg-bottom-0 gray-8">{{ messagePreview }}</p>
        </div>
        <div class="section__item">
          <a-typography-text strong> Plantilla de correo: </a-typography-text>
          <p class="mrg-bottom-0 gray-8">{{ templateEmail }}</p>
        </div>
        <div class="section__item">
          <a-typography-text strong> Horario de envío: </a-typography-text>
          <p class="mrg-bottom-0 gray-8">{{ executionTime ? executionTime : "Manual" }}</p>
        </div>
      </div>
      <div v-else>
        <div v-if="dataSource.queue" class="section__item">
          <a-typography-text strong> Cola: </a-typography-text>
          <p class="mrg-bottom-0 gray-8">{{ dataSource.queue }}</p>
        </div>
        <div v-if="destination" class="section__item">
          <a-typography-text strong> Destino: </a-typography-text>
          <p class="mrg-bottom-0 gray-8">{{ destination }}</p>
        </div>
        <div v-if="typeAssignment" class="section__item">
          <a-typography-text strong> Tipo de asignación: </a-typography-text>
          <p class="mrg-bottom-0 gray-8">{{ typeAssignment }}</p>
        </div>
        <div v-if="typePhone" class="section__item">
          <a-typography-text strong> Tipo de teléfono: </a-typography-text>
          <p class="mrg-bottom-0 gray-8">{{ typePhone }}</p>
        </div>
        <div v-if="typeContact" class="section__item">
          <a-typography-text strong> Tipo de contactos: </a-typography-text>
          <p class="mrg-bottom-0 gray-8">{{ typeContact }}</p>
        </div>
        <div v-if="idAssociated" class="section__item">
          <a-typography-text strong>
            Identificador asociado:

            <a-tooltip
              title="Número de WhatsApp por el cual se le enviará la plantilla de WhatsApp al contacto."
            >
              <InfoCircleOutlined />
            </a-tooltip>
          </a-typography-text>
          <p class="mrg-bottom-0 gray-8">{{ idAssociated }}</p>
        </div>
      </div>
    </a-space>
  </section>
</template>
<script lang="ts" setup>
import { computed, ref } from "vue";
import { DataSourceStrategy } from "@/@types/strategies/modalStrategy";
import {
  TYPES_ASSIGNMENT,
  TYPES_PHONES,
  TYPES_CONTACT,
  TYPES_DESTINATION,
} from "@/app/strategies/utils/modalStrategy";
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import { StrategyType } from "@/app/shared/utils/enums";

const props = defineProps<{
  dataSource: DataSourceStrategy;
  strategyOrigin: number;
}>();

const dataSource = computed(() => {
  console.log(props.dataSource, "props.dataSource");
  console.log(props.strategyOrigin, "props.strategyOrigin");
  return props.dataSource;
});

const isEmail = computed(() => {
  if (dataSource.value.type_strategy === StrategyType.email) return true;
  return false;
});

const typeAssignment = computed(() => {
  if (!dataSource.value.type_assignment) return;
  return TYPES_ASSIGNMENT[dataSource.value.type_assignment] || null;
});

const typePhone = computed(() => {
  if (!dataSource.value.type_phone) return;
  return TYPES_PHONES[dataSource.value.type_phone] || null;
});

const typeContact = computed(() => {
  if (!Object.prototype.hasOwnProperty.call(dataSource.value, "coverage")) return;
  return TYPES_CONTACT[`${dataSource.value.coverage}`] || null;
});

const idAssociated = computed(() => {
  return dataSource.value.template_whatsapp?.associate;
});

const executionTime = computed(() => (isEmail.value ? dataSource.value?.execution_time : ""));

const subject = computed(() => (isEmail.value ? dataSource.value?.subject : ""));

const messagePreview = computed(() => (isEmail.value ? dataSource.value?.message_preview : ""));

const emailAddress = computed(() =>
  isEmail.value ? dataSource.value?.email_config?.from_email : ""
);

const templateEmail = computed(() => (isEmail.value ? dataSource.value?.template_email?.name : ""));

const destination = computed(() => {
  if (!dataSource.value.destination) return;
  return TYPES_DESTINATION[dataSource.value.destination] || null;
});
</script>
<style lang="sass" scoped>
.gray-8
  color: $gray-8
.section
  &__email
    p
      margin-bottom: 20px
</style>
